export const CohortSummaryLoading = () => {
  return (
    <>
      <div className="my-14 !mt-[150px]  flex h-96 animate-pulse items-center gap-2 rounded-2xl border bg-gray-200 p-5"></div>
    </>
  );
};
